<div class="flex min-h-[calc(100vh-48px)] flex-col gap-5 bg-light-color px-6 py-6 font-base text-dark-color">
  <header
    class="flex flex-col gap-4 rounded-2xl bg-gradient-to-r from-[var(--primary-color)] via-[var(--primary-color-hover)] to-[var(--second-color)] px-6 py-6 text-light-color shadow-[0_14px_40px_var(--box-shadow-color)] md:flex-row md:items-start md:justify-between md:gap-6">
    <div class="flex flex-col gap-2">
      <p class="text-xs uppercase tracking-[0.12em] text-light-color/80">Listas</p>
      <h1 class="text-2xl font-semibold leading-tight">Gerencie suas listas e contatos</h1>
      <p class="max-w-3xl text-sm text-light-color/90">
        Cadastre novas listas, importe contatos via CSV e inclua números manualmente para organizar seus envios.
      </p>
    </div>
    <div class="grid grid-cols-2 gap-3 text-sm md:grid-cols-2">
      <div class="rounded-xl bg-white/10 px-4 py-3 shadow">
        <p class="m-0 text-xs uppercase tracking-[0.12em] text-light-color/80">Listas cadastradas</p>
        <strong class="text-lg">{{ listListas.length || 0 }}</strong>
      </div>
      <div class="rounded-xl bg-white/10 px-4 py-3 shadow">
        <p class="m-0 text-xs uppercase tracking-[0.12em] text-light-color/80">Importações CSV</p>
        <strong class="text-lg">Ativas</strong>
      </div>
    </div>
  </header>

  <section class="flex flex-col gap-4 rounded-xl border border-border-color bg-white px-5 py-5 shadow-[0_12px_36px_var(--box-shadow-color)]">
    <div class="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
      <div class="flex items-center gap-2 text-sm text-dark-color">
        <mat-icon>playlist_add</mat-icon>
        <span>Controle unificado de listas e importações.</span>
      </div>
      <div class="flex flex-wrap gap-2">
        <button
          type="button"
          (click)="openModalImportFileCsv()"
          class="inline-flex items-center gap-2 rounded-base border border-border-color bg-white px-4 py-2 text-sm font-semibold text-dark-color shadow-sm transition hover:border-primary-color">
          <mat-icon>upload_file</mat-icon>
          Importar CSV
        </button>
        <button
          type="button"
          (click)="openModalInserirNovaLista()"
          class="inline-flex items-center gap-2 rounded-base bg-primary-color px-4 py-2 text-sm font-semibold text-white shadow-md transition hover:bg-primary-hover">
          <mat-icon>add</mat-icon>
          Nova Lista
        </button>
      </div>
    </div>

    <div class="grid grid-cols-1 gap-4 lg:grid-cols-2">
      <div class="rounded-xl border border-border-color bg-white p-4 shadow">
        <h3 class="text-base font-semibold text-dark-color">Inserção manual</h3>
        <p class="text-sm text-dark-color/70">Inclua um contato em uma lista específica.</p>
        <form class="mt-3 space-y-3" [formGroup]="formInputManual" (ngSubmit)="handleSubmitInputManual()">
          <label class="block text-sm text-dark-color">
            Nome
            <input
              type="text"
              placeholder="Insira o Nome"
              formControlName="nome"
              [ngClass]="{'ring-1 ring-red-500': formInputManual.get('nome')?.touched && formInputManual.get('nome')?.invalid}"
              class="mt-1 w-full rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" />
          </label>
          <p
            *ngIf="formInputManual.get('nome')?.errors?.['required'] && formInputManual.get('nome')?.touched"
            class="text-xs font-medium text-red-600">
            Um nome é requerido.
          </p>

          <label class="block text-sm text-dark-color">
            Número
            <input
              type="text"
              placeholder="(11) 99999-9999"
              formControlName="number"
              (keypress)="handleMaskPhone()"
              [ngClass]="{'ring-1 ring-red-500': formInputManual.get('number')?.touched && formInputManual.get('number')?.invalid}"
              class="mt-1 w-full rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" />
          </label>
          <p
            *ngIf="formInputManual.get('number')?.errors?.['required'] && formInputManual.get('number')?.touched"
            class="text-xs font-medium text-red-600">
            Um número de telefone é requerido.
          </p>

          <label class="block text-sm text-dark-color">
            Lista
            <select
              formControlName="idList"
              [ngClass]="{'ring-1 ring-red-500': formInputManual.get('idList')?.touched && formInputManual.get('idList')?.invalid}"
              class="mt-1 w-full rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color">
              <option value="" disabled selected>Selecione uma Lista</option>
              <option *ngFor="let optionLista of listListas; trackBy: trackByIdLista" [value]="optionLista.idlist">
                {{ optionLista.nome }}
              </option>
            </select>
          </label>
          <p
            *ngIf="formInputManual.get('idList')?.errors?.['required'] && formInputManual.get('idList')?.touched"
            class="text-xs font-medium text-red-600">
            Selecione uma lista.
          </p>

          <button
            type="submit"
            [disabled]="formInputManual.invalid"
            class="mt-2 inline-flex w-full items-center justify-center gap-2 rounded-base bg-primary-color px-4 py-2 text-sm font-semibold text-white shadow transition hover:bg-primary-hover disabled:cursor-not-allowed disabled:opacity-60">
            Salvar
          </button>
        </form>
      </div>

      <div class="rounded-xl border border-border-color bg-white shadow">
        <div class="border-b border-border-color px-4 py-3 flex items-center justify-between">
          <h3 class="m-0 text-base font-semibold text-dark-color">Listas</h3>
          <span class="text-sm text-dark-color/70">Total: {{ listListas.length || 0 }}</span>
        </div>
        <div class="overflow-x-auto">
          <table class="min-w-full divide-y divide-border-color text-sm">
            <thead class="bg-light-color/60">
              <tr>
                <th class="px-4 py-3 text-left font-semibold text-dark-color w-28">ID</th>
                <th class="px-4 py-3 text-left font-semibold text-dark-color">Nome</th>
                <th class="px-4 py-3 text-right font-semibold text-dark-color w-40">Opções</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-border-color">
              <tr
                *ngFor="let lista of listListas; trackBy: trackByIdLista; let i = index"
                class="transition hover:bg-light-color/60">
                <td class="px-4 py-3">
                  <span class="rounded-lg bg-light-color px-2 py-1 text-xs font-semibold text-dark-color/80">#{{ lista.idlist }}</span>
                </td>
                <td class="px-4 py-3 text-dark-color">{{ lista.nome }}</td>
                <td class="px-4 py-3">
                  <div class="flex justify-end gap-2">
                    <button
                      type="button"
                      title="Baixar contatos"
                      class="flex h-9 w-9 items-center justify-center rounded-lg border border-border-color bg-white text-dark-color transition hover:border-primary-color hover:text-primary-color"
                      (click)="downloadListNumber(lista.idlist, lista.nome)">
                      <mat-icon>download</mat-icon>
                    </button>
                    <button
                      type="button"
                      title="Visualizar contatos"
                      class="flex h-9 w-9 items-center justify-center rounded-lg border border-border-color bg-white text-dark-color transition hover:border-primary-color hover:text-primary-color"
                      (click)="openModalViewNumbersInList(lista.idlist)">
                      <mat-icon>visibility</mat-icon>
                    </button>
                    <button
                      type="button"
                      title="Excluir Lista"
                      class="flex h-9 w-9 items-center justify-center rounded-lg border border-border-color bg-white text-red-600 transition hover:border-primary-hover hover:text-primary-hover"
                      (click)="handleDeleteLista(lista.idlist, i)">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </td>
              </tr>
              <tr *ngIf="!listListas.length">
                <td colspan="3" class="px-4 py-6 text-center text-dark-color/70">
                  Nenhuma lista cadastrada.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </section>
</div>

<!-- MODAL: Inserir Nova Lista -->
<ng-container *ngIf="modalInserirLista">
  <div class="fixed inset-0 z-50 grid place-items-center p-4">
    <div class="fixed inset-0 bg-black/50 backdrop-blur-sm" (click)="closeModalInserirNovaLista()"></div>
    <div role="dialog" aria-modal="true" class="relative w-full max-w-md rounded-2xl border border-border-color bg-white p-5 shadow-xl">
      <div class="mb-3 flex items-center justify-between">
        <h3 class="text-base font-semibold text-dark-color">Nova Lista</h3>
        <button
          type="button"
          class="flex h-9 w-9 items-center justify-center rounded-lg border border-border-color bg-white text-dark-color transition hover:border-primary-color"
          (click)="closeModalInserirNovaLista()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <form [formGroup]="formInserirLista" class="space-y-3" (ngSubmit)="onHandleSubmitAdicionarLista()">
        <label class="block text-sm text-dark-color">
          Nome da nova lista
          <input
            type="text"
            placeholder="Insira o nome da nova lista"
            formControlName="nome"
            class="mt-1 block w-full max-w-full box-border rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" />
        </label>

        <button
          class="inline-flex w-full items-center justify-center gap-2 rounded-base bg-primary-color px-4 py-2 text-sm font-semibold text-white shadow transition hover:bg-primary-hover">
          Salvar
        </button>
      </form>
    </div>
  </div>
</ng-container>

<!-- MODAL: Ver números da Lista -->
<ng-container *ngIf="modalViewNumbersInList">
  <div class="fixed inset-0 z-50 grid place-items-center p-4">
    <div class="fixed inset-0 bg-black/50 backdrop-blur-sm" (click)="closeModalViewNumbersInList()"></div>
    <div
      role="dialog"
      aria-modal="true"
      class="relative flex max-h-[85vh] w-full max-w-5xl flex-col overflow-hidden rounded-2xl border border-border-color bg-white shadow-xl">
      <div class="flex items-center justify-between border-b border-border-color px-5 py-4">
        <h3 class="text-base font-semibold text-dark-color">Contatos da Lista</h3>
        <button
          type="button"
          class="flex h-9 w-9 items-center justify-center rounded-lg border border-border-color bg-white text-dark-color transition hover:border-primary-color"
          (click)="closeModalViewNumbersInList()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="flex-1 overflow-y-auto px-5 py-4">
        <div class="overflow-x-auto rounded-xl border border-border-color">
          <table class="min-w-full divide-y divide-border-color text-sm">
            <thead class="bg-light-color/60">
              <tr>
                <th class="px-4 py-3 text-left font-semibold text-dark-color w-24">ID</th>
                <th class="px-4 py-3 text-left font-semibold text-dark-color">Nome</th>
                <th class="px-4 py-3 text-left font-semibold text-dark-color">Número</th>
                <th class="px-4 py-3 text-right font-semibold text-dark-color w-20">Opções</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-border-color">
              <tr
                *ngFor="let numberList of listNumbersInList; let i = index; trackBy: trackByIdNumberList"
                class="transition hover:bg-light-color/60">
                <td class="px-4 py-3 text-dark-color">{{ numberList.id }}</td>
                <td class="px-4 py-3 text-dark-color">{{ numberList.nome }}</td>
                <td class="px-4 py-3 text-dark-color">{{ numberList.numero }}</td>
                <td class="px-4 py-3">
                  <div class="flex justify-end">
                    <button
                      type="button"
                      class="flex h-9 w-9 items-center justify-center rounded-lg border border-border-color bg-white text-red-600 transition hover:border-primary-hover hover:text-primary-hover"
                      (click)="deleteNumberInList(i)">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </td>
              </tr>
              <tr *ngIf="!listNumbersInList.length">
                <td colspan="4" class="px-4 py-6 text-center text-dark-color/70">
                  Nenhum contato encontrado nesta lista.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<!-- MODAL: Importar CSV -->
<ng-container *ngIf="modalImportFileCsv">
  <div class="fixed inset-0 z-50 grid place-items-center p-4">
    <div class="fixed inset-0 bg-black/50 backdrop-blur-sm" (click)="closeModalImportFileCsv()"></div>
    <div role="dialog" aria-modal="true" class="relative w-full max-w-xl rounded-2xl border border-border-color bg-white p-5 shadow-xl">
      <div class="flex items-center justify-between border-b border-border-color pb-3">
        <h3 class="text-base font-semibold text-dark-color">Importar Arquivo CSV</h3>
        <button
          type="button"
          class="flex h-9 w-9 items-center justify-center rounded-lg border border-border-color bg-white text-dark-color transition hover:border-primary-color"
          (click)="closeModalImportFileCsv()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <form class="mt-4 space-y-4 w-full" [formGroup]="formImportFileCsv" (ngSubmit)="handleSubmitImportFileCsv()">
        <div
          class="relative flex flex-col items-center justify-center rounded-base border-2 border-dashed border-border-color px-4 py-8 text-center transition hover:border-primary-color focus-within:border-primary-color">
          <mat-icon class="mb-2 text-dark-color">upload_file</mat-icon>
          <p class="text-sm text-dark-color/80">Selecione o arquivo CSV</p>
          <input
            type="file"
            name="fileInput"
            id="fileInput"
            accept=".csv"
            (change)="handleFileInput($event)"
            class="absolute inset-0 h-full w-full cursor-pointer opacity-0" />
          <button
            type="button"
            (click)="removeFileCsv()"
            class="mt-3 inline-flex items-center justify-center rounded-base border border-border-color bg-white px-3 py-2 text-xs font-medium text-dark-color transition hover:border-primary-color">
            Remover Arquivo
          </button>
        </div>

        <p class="text-xs text-dark-color/80">
          Para importar, os <strong>nomes</strong> devem estar na <strong>coluna A</strong> e os
          <strong>números</strong> na <strong>coluna B</strong>.
        </p>

        <label class="block text-sm text-dark-color">
          Selecione a Lista
          <select
            id="options"
            formControlName="idList"
            class="mt-1 w-full rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color">
            <option value="" disabled selected>Selecione</option>
            <option *ngFor="let lista of listListas; trackBy: trackByIdLista" [value]="lista.idlist">
              {{ lista.nome }}
            </option>
          </select>
        </label>

        <button
          type="submit"
          class="inline-flex w-full items-center justify-center gap-2 rounded-base bg-primary-color px-4 py-2 text-sm font-semibold text-white shadow transition hover:bg-primary-hover">
          Salvar
        </button>
      </form>
    </div>
  </div>
</ng-container>

<app-alert></app-alert>
<app-loading-modal></app-loading-modal>
